export default {
  name: 'Article list section - 1',
  tab: 'article list',
  type: 'category-listing-default-section',
  content: {
    title: 'Article list',
    introtext:
      '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>',
    articles:
      '[{"article-title":"Article 1","article-introtext":"<p>Etiam porta sem malesuada magna mollis euismod. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Maecenas faucibus mollis interdum.</p>","article-image":"","button-text":"","button-link":"#","button-style":"default","button-background-color":"var(--primary-color)","button-text-color":"var(--text-light-color)"},{"article-title":"Article 2","article-introtext":"<p>Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Curabitur blandit tempus porttitor. Nullam quis risus eget urna mollis ornare vel eu leo. Maecenas faucibus mollis interdum.</p>","article-image":"","button-text":"","button-link":"#","button-style":"default","button-background-color":"var(--primary-color)","button-text-color":"var(--text-light-color)"},{"article-title":"Article 3","article-introtext":"<p>Maecenas sed diam eget risus varius blandit sit amet non magna. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>","article-image":"","button-text":"","button-link":"#","button-style":"default","button-background-color":"var(--primary-color)","button-text-color":"var(--text-light-color)"}]'
  },
  design: {
    'background-color': 'var(--background-color)',
    'background-image':
      '/storage/media/samples/lucas-davies-UfmAKd2GKHY-unsplash.jpg',
    'background-image-tablet': '',
    'background-image-mobile': '',
    'parallax-background-image': '0',
    'custom-padding': '1',
    'padding-top': '100px',
    'padding-bottom': '100px',
    'title-color': 'var(--text-light-color)',
    'title-font-weight': 'var(--title-font-weight)',
    'title-tag': 'h2',
    'introtext-color': 'var(--text-light-color)',
    'article-title-color': 'inherit',
    'article-title-font-weight': 'lighter',
    'article-title-tag': 'h6',
    'article-introtext-color': 'inherit'
  },
  layout: {
    'content-container-fluid': '0',
    'content-container-size': 'md',
    'content-horizontal-alignment': 'start',
    'article-columns': '1',
    'content-box': '1',
    'content-box-wrap': 'item',
    'content-box-color': 'white',
    'content-box-padding': '40px',
    'content-box-opacity': '1',
    'content-box-elevation': '0',
    'content-box-border': '0',
    'content-box-border-color': 'var(--text-dark-color)',
    'content-box-rounded': '1'
  },
  advanced: {}
}
